import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n);

const messages = {
    "en": {
        login: {
            username: 'Username',
            password: 'Password',
        },
        app_drawer: {
            user: 'Users',
            feature: 'Features',
            company: 'Companies',
            event: 'Events',
            guest: 'Guests',
            app: 'Mobile Apps',
        },
        user: {
            create: 'Create User',
            edit: 'Edit User',
            email: 'Email',
            password: 'Password',
            change_password: 'Change Password',
            confirm_password: 'Confirm Password',
            new_password: 'New Password',
            remark: 'Remark',
            role: 'Role',
            company: 'Company',
            event: 'Event',
            created_at: 'Created At',
            updated_at: 'Updated At',
            confirm_delete: 'Confirm DELETE User?',
            permission: {
                super: 'Super Admin',
                company: 'Company Admin',
                event: 'Event Admin',
            },
            search: 'Search Email',
        },
        feature: {
            create: 'Create Feature',
            edit: 'Edit Feature',
            id: 'ID',
            name: 'Name',
            feature_id: 'Feature ID',
            created_at: 'Created At',
            updated_at: 'Updated At',
            default_icon: "Default Icon"
        },
        company: {
            create: 'Create Company',
            edit: 'Edit Company',
            id: 'ID',
            name: 'Name',
            domain: 'Company Domain',
            created_at: 'Created At',
            updated_at: 'Updated At',
        },
        guest: {
            create: 'Create Guest',
            edit: 'Edit Guest',
            id: 'ID',
            name: 'First Name',
            username: 'Username',
            company: 'Company',
            metadata: 'Metadata',
            created_at: 'Created At',
            updated_at: 'Updated At',

            details: 'Details',
            events: 'Events',
        },
        merchant: {
            edit: 'Edit Merchant',
            add: 'Add Merchants',
            create: 'Create Merchant'
        },
        evoucher: {
            edit: 'Edit Evoucher',
            add: 'Add Evouchers',
            create: 'Create Evoucher',
            confirm_delete: 'Confirm DELETE Evoucher?'
        },
        event: {
            create: 'Create Event',
            edit: 'Edit Event',
            details: 'Details',
            id: 'ID',
            name: 'Name',
            start_date: 'Start Date',
            end_date: 'End Date',
            companyId: 'Company',
            'cms-tabs': 'CMS Tabs',
            features: 'Features',
            layouts: 'Layouts',
            colors: 'Colors',
            home: 'Home',
            about: 'About',
            agenda: 'Agenda',
            restaurant: 'Restaurant',
            news: 'News',
            faq: 'FAQ',
            general:'General',
            room: 'Room',
            'promo-code': 'Promo Code',
            document: 'Document',
            icon: 'Icon',
            'useful-information': 'Useful\nInformation',
            transport: 'Transport',
            galleries: 'Galleries',
            speaker: 'Speakers',
            notifications: 'Notifications',
            notification: 'Notification',
            'notification-group': 'Notification Group',
            'notification-groups': 'Notification\nGroups',
            'single-notification': 'Single\nNotification',
            guest: 'Guests',
            guests: 'Guests',
            profile: 'Profile',
            sponsor: 'Sponsors',
            order: 'Order',
            report: 'Reports',
            merchant: 'Merchants',
            evoucher: 'Evouchers',
            flight: 'Flight',
            iframe: 'iFrame',
        },
        event_cms_tabs: {
            name: 'CMS Tab',
        },
        event_feature: {
            name: 'Feature',
            confirm_delete: 'Confirm DELETE Feature?',
        },
        event_layout: {
            style: 'Style',
            banner: 'Banner',
            recommendedBannerSize: '(680 x 260)',
        },
        event_color: {
            primary: "Primary",
            primaryLight: "Primary (Light)",
            primaryDarker: "Primary (Dark)",
            background: "Background",
            menuBG: "Menu Background",
            menuText: "Menu Text",
            menuIcon: "Menu Icon",
            menuTintBG: "Menu Background Tint",
            menuTint: "Menu Tint",
            menuTintIcon: "Menu Icon Tint",
            statusBG: "Status Background",
            save_successful: 'Color Saved',
        },
        event_home: {
            html_styles: 'HTML Styles',
            html_content: 'HTML Content',
            banner: 'Banner',
            recommendedBannerSize: '(680 x 260)',
            features: 'Home Features',
            save_successful: 'Home Saved',
        },
        home_feature: {
            title: 'Feature',
            order: 'Order',
            name: 'In-app Name',
            icon: 'Icon',
            feature: 'Feature',
            confirm_delete: 'Confirm DELETE Feature?',
            recommendedIconSize: '(200 x 200)',
            default_icon: 'Default Icon',
            personal_icon: 'Personal Icon',
        },
        event_menu: {
            html_styles: 'HTML Styles',
            html_content: 'HTML Content',
            banner: 'Banner',
            recommendedBannerSize: '(680 x 260)',
            features: 'SideMenu Features',
            save_successful: 'SideMenu Saved',
        },
        menu_feature: {
            title: 'Feature',
            order: 'Order',
            name: 'In-app Name',
            icon: 'Icon',
            feature: 'Feature',
            confirm_delete: 'Confirm DELETE Feature?',
            recommendedIconSize: '(200 x 200)',
            default_icon: 'Default Icon',
            personal_icon: 'Personal Icon',
        },
        event_about: {
            html_content: 'HTML Content',
            save_successful: 'About Saved',
        },
        event_agenda: {
            is_auto_agenda_group: 'Auto Tick New Guest into Agenda',
            intro: 'Intro',
            agenda_type: 'Agenda Type',
            items: 'Agenda Items',
            date: 'Date',
            title: 'Title',
            title_tc: 'Title (Traditional Chinese)',
            title_sc: 'Title (Simplified Chinese)',
            address_type: 'Address Type',
            address: 'Address',
            address_tc: 'Address (Traditional Chinese)',
            address_sc: 'Address (Simplified Chinese)',
            live_stream_link: 'Live Stream URL',
            banner: 'Banner',
            save_successful: 'Agenda saved',
        },
        agenda_item: {
            title: 'Agenda Item',
            date_string: 'Date String',
            start_time: 'Start Time',
            end_time: 'End Time',
            speaker: 'Speaker',
            moderator: 'Moderator',
            order: 'Order',
            html_desc: 'Description',
            html_desc_tc: 'Description (Traditional Chinese)',
            html_desc_sc: 'Description (Simplified Chinese)',
            html_content: 'Content',
            html_content_tc: 'Content (Traditional Chinese)',
            html_content_sc: 'Content (Simplified Chinese)',
            agenda_item_key: 'Agenda Item Key',
            location: 'Location',
            location_tc: 'Location (Traditional Chinese)',
            location_sc: 'Location (Simplified Chinese)',
            live: 'Live',
            picture: 'Picture',
            save_successful: 'Agenda item saved',
            session: 'Session',
            flight: 'Flight',
            tag: 'Tag',
            tag_tc: 'Tag (Traditional Chinese)',
            tag_sc: 'Tag (Simplified Chinese)',
            track: 'Track',
            track_tc: 'Track (Traditional Chinese)',
            track_sc: 'Track (Simplified Chinese)',
        },
        event_restaurant: {
            items: 'Restaurant Items',
            name: 'Name',
            name_tc: 'Name (Traditional Chinese)',
            name_sc: 'Name (Simplified Chinese)',
            address: 'Address',
            address_tc: 'Address (Traditional Chinese)',
            address_sc: 'Address (Simplified Chinese)',
            address_description: 'Address Description',
            address_description_tc: 'Address Description (Traditional Chinese)',
            address_description_sc: 'Address Description (Simplified Chinese)',
            opening_hours: 'Opening Hours',
            contact: 'Contact',
            key: 'Key',
            mapId: 'Map ID',
            mapId_tc: 'Map ID (Traditional Chinese)',
            mapId_sc: 'Map ID (Simplified Chinese)',
            google_map_link: 'Google Map Link',
            google_map_link_tc: 'Google Map Link (Traditional Chinese)',
            google_map_link_sc: 'Google Map Link (Simplified Chinese)',
            banner: 'Banner',
            map: 'Map',
            capacity: 'Capacity',
            is_reserved: 'Reserved',
            meal_box: 'Meal box',
            save_successful: 'Restaurant saved',
            confirm_delete: 'Confirm DELETE restaurant?',
            delete_successful: 'Restaurant successfully deleted',
            lunchKey: 'Preference Key'
        },
        restaurant_item: {
            title: 'Restaurant Item',
            order: 'Order',
            restaurant_item_key: 'Restaurant Item Key',
            restaurant_item_name: 'Restaurant Item Name',
            restaurant_item_name_tc: 'Restaurant Item Name (Traditional Chinese)',
            restaurant_item_name_sc: 'Restaurant Item Name (Simplified Chinese)',
            restaurant_item_pin_top: 'Restaurant Item Pin Top',
            restaurant_item_pin_left: 'Restaurant Item Pin Left',
            html_desc: 'Description',
            html_desc_tc: 'Description (Traditional Chinese)',
            html_desc_sc: 'Description (Simplified Chinese)',
            confirm_delete: 'Confirm DELETE item?',
            save_successful: 'Item saved'
        },
        event_news: {
            title: 'Title',
            html_desc: 'Description',
            html_content: 'Content',
            scheduled_at: 'Scheduled At',
            scheduled_at_date: 'Schedule Date',
            scheduled_at_time: 'Schedule Time',
            save_successful: 'News has been scheduled'
        },
        event_faq: {
            question: 'Question',
            answer: 'Answer',
            order: 'Order',
            category: 'Category',
            confirm_delete: 'Confirm DELETE Faq?',
            save_successful: 'Faq has been saved',
        },
        event_general: {
            title: 'Title',
            content: 'Content',
            order: 'Order',
            category: 'Category',
            confirm_delete: 'Confirm DELETE General?',
            save_successful: 'General has been saved',
        },
        event_room: {
            order: 'Order',
            key: 'Key',
            name: 'Room Name',
            name_tc: 'Room Name (Traditional Chinese)',
            name_sc: 'Room Name (Simplified Chinese)',
            address: 'Address',
            address_tc: 'Address (Traditional Chinese)',
            address_sc: 'Address (Simplified Chinese)',
            opening_hours: 'Opening Hours',
            opening_hours_tc: 'Opening Hours (Traditional Chinese)',
            opening_hours_sc: 'Opening Hours (Simplified Chinese)',
            start_time: 'Start Time',
            end_time: 'End Time',
            remarks: 'Remarks',
            confirm_delete: 'Confirm DELETE Room?',
            save_successful: 'Room has been saved',
        },
        event_promocode: {
            order: 'Order',
            type: 'Type',
            code: 'Code',
            quota: 'Quota',
            used: 'Used',
            remarks: 'Remarks',
            confirm_delete: 'Confirm DELETE Promo Code?',
            save_successful: 'Promo code has been saved',
        },
        event_document: {
            order: 'Order',
            key: 'Key',
            name: 'Document Name',
            category_1: 'Category 1',
            category_2: 'Category 2',
            link_1: 'Link 1',
            link_2: 'Link 2',
            link_3: 'Link 3',
            type: 'Type',
            icon: 'Icon',
            confirm_delete: 'Confirm DELETE Document?',
            save_successful: 'Document has been saved',
        },
        event_icon: {
            order: 'Order',
            key: 'Key',
            icon: 'Icon',
            icon_url: 'Material Icon',
            name: 'Icon Name',
            name_tc: 'Icon Name (Traditional Chinese)',
            name_sc: 'Icon Name (Simplified Chinese)',
            action: 'Action',
            remarks: 'Remarks',
            description: 'Description',
            description_tc: 'Description (Traditional Chinese)',
            description_sc: 'Description (Simplified Chinese)',
            confirm_delete: 'Confirm DELETE Icon?',
            save_successful: 'Icon has been saved',
        },
        event_useful_information: {
            title: 'Title',
            title_tc: 'Title (Traditional Chinese)',
            title_sc: 'Title (Simplified Chinese)',
            address: 'Address',
            address_tc: 'Address (Traditional Chinese)',
            address_sc: 'Address (Simplified Chinese)',
            key: 'Key',
            type: 'Type',
            mapId: 'Map ID',
            content: 'Content',
            content_tc: 'Content (Traditional Chinese)',
            content_sc: 'Content (Simplified Chinese)',
            offer: 'Offer',
            openingHours: 'Opening Hours',
            reservation: 'Reservation',
            order: 'Order',
            tags: 'Tags',
            picture: 'Picture',
            confirm_delete: 'Confirm DELETE item?',
            save_successful: 'Item has been saved',
        },
        event_transport: {
            order: 'Order',
            title: 'Title',
            title_tc: 'Title (Traditional Chinese)',
            title_sc: 'Title (Simplified Chinese)',
            tag: 'Tag',
            is_vip: 'Is VIP',
            key: 'Key',
            items: 'Transport Items',
            confirm_delete: 'Confirm DELETE Transport?',
            save_successful: 'Transport has been saved',
            delete_successful: 'Transport successfully deleted'
        },
        transport_item: {
            title: 'Transport Item',
            order: 'Order',
            picture: 'Picture',
            picture_tc: 'Picture (Traditional Chinese)',
            picture_sc: 'Picture (Simplified Chinese)',
            name: 'Name',
            name_tc: 'Name (Traditional Chinese)',
            name_sc: 'Name (Simplified Chinese)',
            key: 'Key',
            address: 'Address',
            address_tc: 'Address (Traditional Chinese)',
            address_sc: 'Address (Simplified Chinese)',
            contact: 'Contact',
            map_link_hint:'https://developers.google.com/maps/documentation/places/web-service/place-id',
            map_link: 'Map Link',
            map_link_tc: 'Map Link (Traditional Chinese)',
            map_link_sc: 'Map Link (Simplified Chinese)',
            content: 'Content',
            content_tc: 'Content (Traditional Chinese)',
            content_sc: 'Content (Simplified Chinese)',
            date: 'Date String',
            confirm_delete: 'Confirm DELETE item?',
            save_successful: 'Item saved'
        },
        event_flight: {
            order: 'Order',
            name: 'Name',
            key: 'Key',
            items: 'Flight Items',
            confirm_delete: 'Confirm DELETE Flight?',
            save_successful: 'Flight has been saved',
            delete_successful: 'Flight successfully deleted'
        },
        flight_item: {
            title: 'Flight Item',
            order: 'Order',
            date: 'Date',
            flight_number: 'Flight Number',
            itinerary: 'Itinerary',
            departure_time: 'Departure Time',
            arrival_time: 'Arrival Time',
            description: 'Description',
            content: 'Content',
            confirm_delete: 'Confirm DELETE item?',
            save_successful: 'Item saved',
            flight_key: 'Keys',
        },
        event_speaker: {
            html_content: 'HTML Content',
            items: 'Speakers',
            save_successful: 'Speaker saved',
            type:'Type',
        },
        speaker_item: {
            photo: 'Photo',
            name: 'Name',
            lastname: 'Lastname',
            title: 'Title',
            company: 'Company',
            bio: 'Biography',
            order: 'Order',
            type: 'Type',
            token: 'Token',
            speaks_at: 'Content',
        },
        event_gallery: {
            title: 'Title',
            key: 'Key',
            link: 'Link',
            tour: 'Tour',
            description: 'Description',
            launch: 'Launch',
            banner: 'Banner',
            recommendedBannerSize: '(680 x 260)',
            photo_count: 'No. of Photo',
            import_photos: 'Import Photo(s)',
            import: 'Import',
            edit: 'Edit Photo Details',
            reorder: 'Gallery Photo Order',
            empty: 'You have not imported any photos in this gallery!',
            save_error_log: 'Save Error Log',
            confirm_delete: 'Confirm DELTE Gallery?',
            confirm_save: 'Confirm SAVE Gallery?',
            confirm_closePhotoItemsEditor: 'Confirm Close Editor?',
            order: 'Order'
        },
        gallery_item: {
            order: 'Order',
            photo: 'Photo',
            photos: 'Photo(s)',
            description: 'Description',
            description_tc: 'Description (Traditional Chinese)',
            description_sc: 'Description (Simplified Chinese)',
            isShown: 'Show/Hide',
            select_photos: 'Please select photo(s)',
            photo_detail: 'Photo Details',
            confirm_delete: 'Confirm DELETE Photo?',
            del_successful: 'Photo Deleted',
            save_successful: 'Photo Saved',
            event_guests: {
                ev_email: 'Guest Email',
                ev_firstname: 'Guest Firstname',
                ev_lastname: 'Guest Lastname'
            },
        },
        sponsor: {
            title: 'Sponsor',
            recommendedBannerSize: '(680 x 260)',
            image_count: 'No. of Image',
            import_images: 'Import Image(s)',
            edit_images: 'Edit Images',
            import: 'Import',
            edit: 'Edit Photo Details',
            reorder: 'Sponors Image Order',
            empty: 'You have not imported any images!',
            save_error_log: 'Save Error Log',
            confirm_save: 'Confirm to save the sponsors?',
            confirm_closePhotoItemsEditor: 'Confirm Close Editor?',
            order: 'Order',
            image: 'Image',
            images: 'Image(s)',
            description: 'Description',
            select_images: 'Please select image(s)',
            confirm_delete: 'Confirm DELETE Image?',
            del_successful: 'Image Deleted',
            save_successful: 'Image Saved',
        },
        event_notification: {
            type: 'Type',
            title: 'Title',
            content: 'Content',
            created_at: 'Created At',
            updated_at: 'Updated At',
            scheduled_at: 'Scheduled At',
            sent_at: 'Sent At',
            notification_group: 'Notification Group',
            scheduled_at_date: 'Schedule Date',
            scheduled_at_time: 'Schedule Time',
            save_successful: 'Notification has been scheduled',
            confirm_delete: 'Confirm DELETE Notification?',
        },
        event_nGroup: {
            name: 'Group Name',
            confirm_delete: 'Confirm DELETE Notification Group?',
            save_successful: 'Notification Group Saved',
            guest_not_found: 'No active guest is found'
        },
        mobile_app: {
            create: 'Create App',
            edit: 'Edit App',
            name: 'Name',
            app_id: 'App ID',
            company: 'Company',
            app_type: 'App Type',
            forgot_password: 'Forgot Password Message',
            endmessage: 'End Message',
            endmessage_tc: 'End Message (Traditional Chinese)',
            endmessage_sc: 'End Message (Simplified Chinese)',
            created_at: 'Created At',
            updated_at: 'Updated At',
            banner: 'Banner',
            recommendedBannerSize: '(680 x 260)',
            force_update_ios_version: 'Force Update iOS Version',
            force_update_ios_link: 'Force Update link ( AppStore link )',
            force_update_android_version: 'Force Update Android Version',
            force_update_android_link: 'Force Update link ( PlayStore link )',
        },
        cms_tab: {
            title: "Title",
            status: "Status",
            save_successful: "Cms tab Saved"
        },
        event_profile: {
            title: "Title",
            status: "In-app Status",
        },
        search: 'Search',
        edit: 'Edit',
        delete: 'Delete',
        save: 'Save',
        ok: 'OK',
        cancel: 'Cancel',
        revert: 'Revert',
        add: 'Add',
        yes: 'Yes',
        no: 'No',
        close: 'Close',
    },
    "zh": {},
};

const i18n = new VueI18n({
    locale: 'en',
    messages,
});

export default i18n;